import {
    CLICK_CREDIT_APP_SEND_LINK,
    CLICK_CREDIT_BUREAU_SCORES_LINK,
    CLICK_CUSTOMER_NAME_OR_CO_BUYER_LINK,
    SELECT_OFFER_CREDIT_RATING_DROPDOWN,
    CLICK_OPEN_DEAL_IN_FI_BUTTON,
    CLICK_TEST_DRIVE_SEND_LINK,
    CLICK_UPLOAD_DOCS_SEND_LINK,
    VIEW_IN_VAUTO_LINK,
    CLICK_MAKE_CURRENT_BUTTON,
    CLICK_MAKE_CURRENT_LINK,
    CLICK_VALUE_TRADE_IN_START_LINK,
    CLICK_TRADE_IN_EDIT_BUTTON,
    CLICK_VEHICLE_DETAILS_LINK,
    CLICK_QUICK_COMPARE_LINK,
    CLICK_OFFER_HISTORY_BUTTON,
    CLICK_DEAL_PROGRESS_UPDATE_BUTTON,
    CLICK_TRADE_INCLUDE_WITH_OFFER_CHECKBOX,
    CLICK_START_APPRAISAL_LINK,
    CLICK_ADD_ACCESSORIES_LINK,
    CLICK_PROGRAMS_AND_INCENTIVES_ADD_LINK,
    CLICK_VEHICLE_ACCESSORIES_START_LINK,
    CLICK_VEHICLE_ACCESSORIES_EDIT_LINK,
    CLICK_VEHICLE_PROTECTION_START_LINK,
    CLICK_VEHICLE_PROTECTION_EDIT_LINK,
    CLICK_APPLY_VEHICLE_PROTECTION_BUTTON,
    CLICK_OPEN_FLEXIBLE_PROTECTION_PRODUCTS_ENTRY_LINK,
    CLICK_REMOVE_MANUALLY_ADDED_PROTECTION_PRODUCT_ICON,
    CLICK_OPEN_VEHICLE_PROTECTION_FROM_CATALOG_LINK,
    UPDATE_ADD_PROTECTION_PRODUCT_MANUALLY_TEXT_INPUT,
    CLICK_PROGRAMS_AND_INCENTIVES_START_LINK,
    CLICK_PROGRAMS_AND_INCENTIVES_EDIT_LINK,
    CLICK_APPLY_PROGRAMS_AND_INCENTIVES_BUTTON,
    UPDATE_ACQ_FEE_TEXT_INPUT,
    CLICK_ACQ_FEE_UPFRONT_CHECKBOX,
    UPDATE_SECURITY_DEPOSIT_TEXT_INPUT,
    UPDATE_COST_PER_MILE_TEXT_INPUT,
    UPDATE_BASE_RESIDUAL_TEXT_INPUT,
    CLICK_BASE_RESIDUAL_DOLLARS_BUTTON,
    CLICK_BASE_RESIDUAL_PERCENT_BUTTON,
    UPDATE_ADJUSTED_RESIDUAL_TEXT_INPUT,
    CLICK_ADJUSTED_RESIDUAL_DOLLARS_BUTTON,
    CLICK_ADJUSTED_RESIDUAL_PERCENT_BUTTON,
    SELECT_MILES_PER_YEAR_DROPDOWN,
    CLICK_DEAL_TYPE_DROPDOWN_FINANCE,
    CLICK_DEAL_TYPE_DROPDOWN_LEASE,
    CLICK_DEAL_TYPE_DROPDOWN_CASH,
    CLICK_ROLL_TO_PAYMENT_APPLY_BUTTON,
    CLICK_DEAL_LIST_LINK,
    UPDATE_CASH_MSRP_TEXT_INPUT,
    UPDATE_CASH_SELLING_PRICE_TEXT_INPUT,
    UPDATE_FINANCE_MSRP_TEXT_INPUT,
    UPDATE_FINANCE_SELLING_PRICE_TEXT_INPUT,
    UPDATE_FINANCE_CASH_DOWN_TEXT_INPUT,
    SELECT_FINANCE_LENDER_DROPDOWN,
    UPDATE_FINANCE_TERM_DROPDOWN,
    UPDATE_LEASE_MSRP_TEXT_INPUT,
    UPDATE_LEASE_SELLING_PRICE_TEXT_INPUT,
    UPDATE_LEASE_CASH_DOWN_TEXT_INPUT,
    SELECT_LEASE_LENDER_DROPDOWN,
    UPDATE_LEASE_TERM_DROPDOWN,
    CLICK_GENERATE_CONTRACT_BUTTON,
    CLICK_GENERATE_CONTRACT_CONFIRM_BUTTON,
    CLICK_MANAGE_DOCUMENTS_BUTTON,
    CLICK_PRINT_BUTTON,
    CLICK_FUNCTIONS_BUTTON,
    SELECT_FINANCE_LENDER_DECISION_DROPDOWN,
    UPDATE_FINANCE_SELL_RATE_TEXT_INPUT,
    UPDATE_FINANCE_BUY_RATE_TEXT_INPUT,
    SELECT_LEASE_LENDER_DECISION_DROPDOWN,
    UPDATE_LEASE_SELL_RATE_TEXT_INPUT,
    UPDATE_LEASE_BUY_RATE_TEXT_INPUT,
    CLICK_PUSH_TO_DARWIN_BUTTON,
    OPEN_IN_DARWIN_BUTTON,
    ADD_ANOTHER_TRADEIN_LINK,
    DELETE_TRADEIN_ICON,
    TRADEIN_VEHICLE_ACCORDION_SUMMARY,
    CLICK_ALTERNATIVE_VEHICLE_OPTIONS_LINK,
    CLICK_LENDER_APPROVAL_LIKELIHOOD_LINK,
    LENDER_APPROVAL_LIKELIHOOD_VIEWED,
    CLICK_MV_ACCESSORIES_LINK,
    CLICK_MV_LENDER_LINK,
    CLICK_MV_RATE_LINK,
    CLICK_MV_INCENTIVES_LINK,
    CLICK_MV_PROTECTION_LINK,
    CLICK_MV_TAXES_LINK,
    CLICK_MV_FEES_LINK,
    CLICK_MV_TRADE_ALLOWANCE_LINK,
    CLICK_MV_TRADE_PAYOFF_LINK,
    CLICK_MV_CHANGE_VEHICLE,
    CLICK_MV_CHANGE_TO_FI_MODE,
    CLICK_MV_CHANGE_TO_DESKING_MODE,
    CLICK_APPRAISE_TRADE_IN_VEHICLE_LINK,
    APPRAISAL_SLIDE_PANEL_CALLBACK_RECEIVED,
    TRADE_IN_INFO_UPDATE_APPLIED,
    CLICK_OPEN_REPAIR_ORDERS_LINK,
    OPEN_REPAIR_ORDERS_SLIDE_OUT_VIEWED,
    CLICK_SWAP_BUYER_CO_BUYER_BUTTON
} from '../actionTypes/interactionAnalyticsActionTypes';
import type { Vehicle } from '@makemydeal/dr-dash-types';
import type { LenderData } from '@makemydeal/dr-shared-types';
import type { VehicleAnalyticsPayload } from './deskingActionCreators';

export const uploadDocsSendLink = () => ({
    type: CLICK_UPLOAD_DOCS_SEND_LINK
});

export const creditAppSendLink = () => ({
    type: CLICK_CREDIT_APP_SEND_LINK
});

export const viewInVautoLink = () => ({
    type: VIEW_IN_VAUTO_LINK
});

export const testDriveSendLink = () => ({
    type: CLICK_TEST_DRIVE_SEND_LINK
});

export const customerNameOrCoBuyerLink = () => ({
    type: CLICK_CUSTOMER_NAME_OR_CO_BUYER_LINK
});

export const openDealFIBtn = () => ({
    type: CLICK_OPEN_DEAL_IN_FI_BUTTON
});

export const creditBureauScoresLink = () => ({
    type: CLICK_CREDIT_BUREAU_SCORES_LINK
});

export const offerCreditRatingDropdown = () => ({
    type: SELECT_OFFER_CREDIT_RATING_DROPDOWN
});

export const makeCurrentButton = () => ({
    type: CLICK_MAKE_CURRENT_BUTTON
});

export const makeCurrentLink = () => ({
    type: CLICK_MAKE_CURRENT_LINK
});

export const valueTradeInStartLink = () => ({
    type: CLICK_VALUE_TRADE_IN_START_LINK
});

export const tradeInEditButton = () => ({
    type: CLICK_TRADE_IN_EDIT_BUTTON
});

export const vehicleDetailsLink = () => ({
    type: CLICK_VEHICLE_DETAILS_LINK
});

export const quickCompareLink = () => ({
    type: CLICK_QUICK_COMPARE_LINK
});

export const offerHistoryButton = () => ({
    type: CLICK_OFFER_HISTORY_BUTTON
});

export const dealProgressUpdateButton = () => ({
    type: CLICK_DEAL_PROGRESS_UPDATE_BUTTON
});

export const tradeIncludeWithOfferCheckbox = () => ({
    type: CLICK_TRADE_INCLUDE_WITH_OFFER_CHECKBOX
});

export const startAppraisalLink = () => ({
    type: CLICK_START_APPRAISAL_LINK
});

export const addAccessoriesLink = () => ({
    type: CLICK_ADD_ACCESSORIES_LINK
});

export const programsAndIncentivesAddLink = () => ({
    type: CLICK_PROGRAMS_AND_INCENTIVES_ADD_LINK
});

export const vehicleAccessoriesStartLink = () => ({
    type: CLICK_VEHICLE_ACCESSORIES_START_LINK
});

export const vehicleAccessoriesEditLink = () => ({
    type: CLICK_VEHICLE_ACCESSORIES_EDIT_LINK
});

export const vehicleProtectionStartLink = () => ({
    type: CLICK_VEHICLE_PROTECTION_START_LINK
});

export const vehicleProtectionEditLink = () => ({
    type: CLICK_VEHICLE_PROTECTION_EDIT_LINK
});

export const applyVehicleProtectionButton = () => ({
    type: CLICK_APPLY_VEHICLE_PROTECTION_BUTTON
});

export const openFlexibleProtectionProductsEntryLink = () => ({
    type: CLICK_OPEN_FLEXIBLE_PROTECTION_PRODUCTS_ENTRY_LINK
});

export const removeManuallyAddedProtectionProductIcon = () => ({
    type: CLICK_REMOVE_MANUALLY_ADDED_PROTECTION_PRODUCT_ICON
});

export const openVehicleProtectionFromCatalogLink = () => ({
    type: CLICK_OPEN_VEHICLE_PROTECTION_FROM_CATALOG_LINK
});

export const updateAddProtectionProductManuallyTextInput = () => ({
    type: UPDATE_ADD_PROTECTION_PRODUCT_MANUALLY_TEXT_INPUT
});

export const programsAndIncentivesStartLink = () => ({
    type: CLICK_PROGRAMS_AND_INCENTIVES_START_LINK
});

export const programsAndIncentivesEditLink = () => ({
    type: CLICK_PROGRAMS_AND_INCENTIVES_EDIT_LINK
});

export const applyProgramsAndIncentivesButton = () => ({
    type: CLICK_APPLY_PROGRAMS_AND_INCENTIVES_BUTTON
});

export const acqFeeTextInput = () => ({
    type: UPDATE_ACQ_FEE_TEXT_INPUT
});

export const acqFeeUpfrontCheckbox = () => ({
    type: CLICK_ACQ_FEE_UPFRONT_CHECKBOX
});

export const securityDepositTextInput = () => ({
    type: UPDATE_SECURITY_DEPOSIT_TEXT_INPUT
});

export const costPerMileTextInput = () => ({
    type: UPDATE_COST_PER_MILE_TEXT_INPUT
});

export const baseResidualTextInput = () => ({
    type: UPDATE_BASE_RESIDUAL_TEXT_INPUT
});

export const baseResidualDollarsButton = () => ({
    type: CLICK_BASE_RESIDUAL_DOLLARS_BUTTON
});

export const baseResidualPercentButton = () => ({
    type: CLICK_BASE_RESIDUAL_PERCENT_BUTTON
});

export const adjustedResidualTextInput = () => ({
    type: UPDATE_ADJUSTED_RESIDUAL_TEXT_INPUT
});

export const adjustedResidualDollarsButton = () => ({
    type: CLICK_ADJUSTED_RESIDUAL_DOLLARS_BUTTON
});

export const adjustedResidualPercentButton = () => ({
    type: CLICK_ADJUSTED_RESIDUAL_PERCENT_BUTTON
});

export const milesPerYearDropdown = () => ({
    type: SELECT_MILES_PER_YEAR_DROPDOWN
});

export const cashMsrpTextInput = () => ({
    type: UPDATE_CASH_MSRP_TEXT_INPUT
});

export const cashSellingPriceTextInput = () => ({
    type: UPDATE_CASH_SELLING_PRICE_TEXT_INPUT
});

export const financeMsrpTextInput = () => ({
    type: UPDATE_FINANCE_MSRP_TEXT_INPUT
});

export const financeSellingPriceTextInput = () => ({
    type: UPDATE_FINANCE_SELLING_PRICE_TEXT_INPUT
});

export const financeCashDownTextInput = () => ({
    type: UPDATE_FINANCE_CASH_DOWN_TEXT_INPUT
});

export const financeLenderDropdown = (vehicleInfo?: VehicleAnalyticsPayload, lenderId?: string, lenderName?: string) => ({
    type: SELECT_FINANCE_LENDER_DROPDOWN,
    payload: { vehicleInfo, lenderId, lenderName }
});

export const financeTermDropdown = () => ({
    type: UPDATE_FINANCE_TERM_DROPDOWN
});

export const leaseMsrpTextInput = () => ({
    type: UPDATE_LEASE_MSRP_TEXT_INPUT
});

export const leaseSellingPriceTextInput = () => ({
    type: UPDATE_LEASE_SELLING_PRICE_TEXT_INPUT
});

export const leaseCashDownTextInput = () => ({
    type: UPDATE_LEASE_CASH_DOWN_TEXT_INPUT
});

export const leaseLenderDropdown = (vehicleInfo?: VehicleAnalyticsPayload, lenderId?: string, lenderName?: string) => ({
    type: SELECT_LEASE_LENDER_DROPDOWN,
    payload: { vehicleInfo, lenderId, lenderName }
});

export const leaseTermDropdown = () => ({
    type: UPDATE_LEASE_TERM_DROPDOWN
});

export const generateContractButton = () => ({
    type: CLICK_GENERATE_CONTRACT_BUTTON
});

export const generateContractConfirmButton = () => ({
    type: CLICK_GENERATE_CONTRACT_CONFIRM_BUTTON
});

export const manageDocumentsButton = () => ({
    type: CLICK_MANAGE_DOCUMENTS_BUTTON
});

export const printButton = () => ({
    type: CLICK_PRINT_BUTTON
});

export const functionsButton = () => ({
    type: CLICK_FUNCTIONS_BUTTON
});

export const clickDealTypeDropdownFinance = () => ({
    type: CLICK_DEAL_TYPE_DROPDOWN_FINANCE
});

export const clickDealTypeDropdownLease = () => ({
    type: CLICK_DEAL_TYPE_DROPDOWN_LEASE
});

export const clickDealTypeDropdownCash = () => ({
    type: CLICK_DEAL_TYPE_DROPDOWN_CASH
});

export const clickDealListLink = () => ({
    type: CLICK_DEAL_LIST_LINK
});

export const clickRollToPaymentApplyButton = () => ({
    type: CLICK_ROLL_TO_PAYMENT_APPLY_BUTTON
});

export const financeLenderDecisionDropdown = () => ({
    type: SELECT_FINANCE_LENDER_DECISION_DROPDOWN
});

export const financeSellRateTextInput = () => ({
    type: UPDATE_FINANCE_SELL_RATE_TEXT_INPUT
});

export const financeBuyRateTextInput = () => ({
    type: UPDATE_FINANCE_BUY_RATE_TEXT_INPUT
});

export const leaseLenderDecisionDropdown = () => ({
    type: SELECT_LEASE_LENDER_DECISION_DROPDOWN
});

export const leaseSellRateTextInput = () => ({
    type: UPDATE_LEASE_SELL_RATE_TEXT_INPUT
});

export const leaseBuyRateTextInput = () => ({
    type: UPDATE_LEASE_BUY_RATE_TEXT_INPUT
});

export const pushToDarwinButton = () => ({
    type: CLICK_PUSH_TO_DARWIN_BUTTON
});

export const openInDarwinButton = () => ({
    type: OPEN_IN_DARWIN_BUTTON
});
export const addAnotherTradeInLink = () => ({
    type: ADD_ANOTHER_TRADEIN_LINK
});
export const deleteTradeInIcon = () => ({
    type: DELETE_TRADEIN_ICON
});
export const tradeInVehicleAccordionSummary = () => ({
    type: TRADEIN_VEHICLE_ACCORDION_SUMMARY
});

export const clickAlternativeVehicleOptionsLink = (vehicle: Vehicle) => ({
    type: CLICK_ALTERNATIVE_VEHICLE_OPTIONS_LINK,
    payload: { vin: vehicle.vin, make: vehicle.make, model: vehicle.model, year: vehicle.year }
});

export const clickLenderApprovalLikelihoodLink = (lender: LenderData | undefined, vehicle?: Vehicle) => ({
    type: CLICK_LENDER_APPROVAL_LIKELIHOOD_LINK,
    payload: {
        lenderId: lender?.lenderId,
        lenderName: lender?.lender,
        loanLikelihood: lender?.loanLikelihood,
        buyRate: lender?.buyRate,
        vehicle
    }
});

export const lenderApprovalLikelihoodViewed = (lender: LenderData | undefined, vehicle?: Vehicle) => ({
    type: LENDER_APPROVAL_LIKELIHOOD_VIEWED,
    payload: {
        lenderId: lender?.lenderId,
        lenderName: lender?.lender,
        loanLikelihood: lender?.loanLikelihood,
        buyRate: lender?.buyRate,
        vehicle
    }
});

export const mvAccessoriesLink = () => ({
    type: CLICK_MV_ACCESSORIES_LINK
});

export const mvLenderLink = () => ({
    type: CLICK_MV_LENDER_LINK
});

export const mvRateLink = () => ({
    type: CLICK_MV_RATE_LINK
});

export const mvIncentivesLink = () => ({
    type: CLICK_MV_INCENTIVES_LINK
});

export const mvProtectionLink = () => ({
    type: CLICK_MV_PROTECTION_LINK
});

export const mvTaxesLink = () => ({
    type: CLICK_MV_TAXES_LINK
});

export const mvFeesLink = () => ({
    type: CLICK_MV_FEES_LINK
});

export const mvTradeAllowanceLink = () => ({
    type: CLICK_MV_TRADE_ALLOWANCE_LINK
});

export const mvTradePayoffLink = () => ({
    type: CLICK_MV_TRADE_PAYOFF_LINK
});

export const mvChangeVehicle = () => ({
    type: CLICK_MV_CHANGE_VEHICLE
});

export const mvChangeToFIMode = () => ({
    type: CLICK_MV_CHANGE_TO_FI_MODE
});

export const mvChangeToDeskingMode = () => ({
    type: CLICK_MV_CHANGE_TO_DESKING_MODE
});

// dc-mv-307
export const appraiseTradeInVehicleLink = () => ({
    type: CLICK_APPRAISE_TRADE_IN_VEHICLE_LINK
});

export const appraisalSlidePanelCallbackReceived = () => ({
    type: APPRAISAL_SLIDE_PANEL_CALLBACK_RECEIVED
});

export const tradeInInfoUpdateApplied = () => ({
    type: TRADE_IN_INFO_UPDATE_APPLIED
});

// dc-mv-327
export const clickOpenRepairOrdersLink = (vehicle: VehicleAnalyticsPayload) => ({
    type: CLICK_OPEN_REPAIR_ORDERS_LINK,
    payload: { vin: vehicle.vin, make: vehicle.make, model: vehicle.model, year: vehicle.year }
});

// dc-mv-328
export const openRepairOrdersSlideOutViewed = (vehicle: VehicleAnalyticsPayload) => ({
    type: OPEN_REPAIR_ORDERS_SLIDE_OUT_VIEWED,
    payload: { vin: vehicle.vin, make: vehicle.make, model: vehicle.model, year: vehicle.year }
});

// dc-mv-329
export const clickSwapBuyerCoBuyerButton = (vehicle: VehicleAnalyticsPayload) => ({
    type: CLICK_SWAP_BUYER_CO_BUYER_BUTTON,
    payload: { vin: vehicle.vin, make: vehicle.make, model: vehicle.model, year: vehicle.year }
});
